const request = {}

request.createRequest = function (paymentMethodData) {
  return {
    name: paymentMethodData.name,
    sortNumber: paymentMethodData.sortNumber,
    isEnabled: paymentMethodData.isEnabled
  }
}
export default { request }
